<template>
  <div>
    <div class="edit-interests-btn" @click="launchEditEventInterestsModal">
      Edit interests
    </div>
  </div>
</template>

<script>
import HomebaseMixpanelMixin from "@/mixins/HomebaseMixpanelMixin";
import EditEventInterestsModal from "@/components/homebase/modals/EditEventInterestsModal";
import { createStandardModal } from "@/utils/modalHelper";

export default {
  name: "edit-event-interests-button",
  props: ["topics", "showSubtitle"],
  mixins: [HomebaseMixpanelMixin],
  data() {
    return {
      modalInstance: null
    };
  },
  methods: {
    launchEditEventInterestsModal() {
      this.trackEventsEditInterestsClick();

      // Create modal instance using vue-final-modal v4 API
      this.modalInstance = createStandardModal(EditEventInterestsModal, {
        props: {
          topics: this.topics,
          showSubtitle: this.showSubtitle
        },
        callbacks: {
          onInterestsSaved: () => {
            this.handleInterestsSaved();
          }
        }
      });

      // Open the modal
      this.modalInstance.open();
    },

    handleInterestsSaved() {
      this.$emit("interestsSaved");
      this.$parent.$emit("interestsSaved");
    },
  },

  beforeUnmount() {
    // Cleanup modal instance when component is destroyed
    if (this.modalInstance) {
      this.modalInstance.destroy();
    }
  }
};
</script>

<style scoped>
.edit-interests-btn {
  font-family: artifaktElementBold;
  font-size: 16px;
  color: var(--secondary-color);
  text-decoration: underline;
}
.edit-interests-btn:hover {
  cursor: pointer;
  color: var(--secondary-color);
}
</style>